//import axios from "../../_services/axios";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {},
};
